const _normal = "normal"
const _reverse = "reverse"
const _alternate = "alternate"
const config = { "normal": _normal, "reverse": _reverse, "alternate": _alternate, "alternate-reverse": "alternate-reverse",  }
export { config as default, _normal, _reverse, _alternate }